class FormPane {
	constructor() {
		this.container = document.querySelector('.post-type-archive-conference');
		if (!this.container) return;
		this.init();
	}

	init() {
		this.form = document.querySelector("#formPane");
		if (!this.form) return;

		document.body.appendChild(this.form);

		// clic on this.form but not its children (to close the form)
		this.form.addEventListener("click", e => {
			if (e.target !== this.form) return;
			this.form.classList.remove("is-active");
			smoother.paused(false);
		});

		this.openTriggers = document.querySelectorAll(".js-open-form");
		this.openTriggers.forEach(trigger => {
			let file = trigger.dataset.file;
			let filename = trigger.dataset.filename;

			trigger.addEventListener("click", e => {
				e.preventDefault();

				// return;
				this.form.classList.add("is-active");
				// smoother.paused(true);
				if (file && filename) {
					this.form.querySelector("#form-success").dataset.file = file;
					this.form.querySelector("input[name='file_name']").value = filename;
				}
			});
		});

		this.closeTrigger = this.form.querySelector(".form-pane-close");
		if (!this.closeTrigger) return;
		this.closeTrigger.addEventListener("click", e => {
			e.preventDefault();
			this.form.classList.remove("is-active");
			// smoother.paused(false);
		});
	}
}